import HTTP from '.';
import MemberServiceMock from './mocks/MemberService.mock';
import config from '@/config';

export default class MemberService {
  static getCurrentMember() {
    if (config.ENV.MOCK === true) {
      return MemberServiceMock.getCurrentMember();
    }

    return HTTP.get('/api/currentmember', { handleHttpError: false });
  }

  static saveContactInformation(args) {
    if (config.ENV.MOCK === true) {
      return MemberServiceMock.saveContactInformation();
    }

    return HTTP.post('/api/currentmember/contactinformation', args);
  }

  static getCurrentMemberContactInformation() {
    if (config.ENV.MOCK === true) {
      return MemberServiceMock.getCurrentMemberContactInformation();
    }

    return HTTP.get('/api/currentmember/contactinformation');
  }

  static getCurrentProfilePicture() {
    if (config.ENV.MOCK === true) {
      return MemberServiceMock.getCurrentProfilePicture();
    }

    return HTTP.get('/api/currentmember/picture');
  }

  static saveProfilePicture(data) {
    if (config.ENV.MOCK === true) {
      return MemberServiceMock.saveProfilePicture();
    }
    const formData = new FormData();
    formData.append('file', data.file);

    return HTTP.post('/api/currentmember/picture', formData);
  }

  static deleteProfilePicture() {
    if (config.ENV.MOCK === true) {
      return MemberServiceMock.deleteProfilePicture();
    }

    return HTTP.delete('/api/currentmember/picture');
  }

  // ***PREFERENCES***
  static getCurrentMemberCalendarPreferences() {
    if (config.ENV.MOCK === true) {
      return MemberServiceMock.getCurrentMemberCalendarPreferences();
    }

    return HTTP.get('/api/currentmember/preferences/calendar');
  }

  static saveCalendarPreferences(args) {
    if (config.ENV.MOCK === true) {
      return MemberServiceMock.saveCalendarPreferences();
    }

    return HTTP.post('/api/currentmember/preferences/calendar', args);
  }

  static getCurrentMemberNotificationPreferences() {
    if (config.ENV.MOCK === true) {
      return MemberServiceMock.getCurrentMemberNotificationPreferences();
    }

    return HTTP.get('/api/currentmember/preferences/notifications');
  }

  static saveNotificationPreferences(args) {
    if (config.ENV.MOCK === true) {
      return MemberServiceMock.saveNotificationPreferences();
    }

    return HTTP.post('/api/currentmember/preferences/notifications', args);
  }

  static getCurrentMemberEmployment() {
    if (config.ENV.MOCK === true) {
      return MemberServiceMock.getCurrentEmployment();
    }

    return HTTP.get('/api/currentmember/preferences/employment');
  }

  static saveEmployment(args) {
    if (config.ENV.MOCK === true) {
      return MemberServiceMock.saveEmployment();
    }

    return HTTP.post('/api/currentmember/preferences/employment', args);
  }

  static getCurrentMemberSubscriptionPreferences() {
    if (config.ENV.MOCK === true) {
      return MemberServiceMock.getCurrentMemberSubscriptionPreferences();
    }

    return HTTP.get('/api/currentmember/preferences/newsletters');
  }

  static saveSubscriptionPreferences(args) {
    if (config.ENV.MOCK === true) {
      return MemberServiceMock.saveSubscriptionPreferences();
    }

    return HTTP.post('/api/currentmember/preferences/newsletters', args);
  }

  static changePassword(args) {
    if (config.ENV.MOCK === true) {
      return MemberServiceMock.changePassword();
    }

    return HTTP.post('/api/account/changepassword', args);
  }
  // ******

  static getCurrentMemberEmployers() {
    if (config.ENV.MOCK === true) {
      return MemberServiceMock.getCurrentMemberEmployers();
    }

    return HTTP.get('/api/currentmember/employers');
  }

  static getCurrentMemberEmployer(id) {
    if (config.ENV.MOCK === true) {
      return MemberServiceMock.getCurrentMemberEmployer();
    }

    return HTTP.get(`/api/currentmember/employers/${id}`);
  }

  static saveCurrentMemberEmployer(id, data) {
    if (config.ENV.MOCK === true) {
      return MemberServiceMock.saveCurrentMemberEmployer();
    }

    return HTTP.put(`/api/currentmember/employers/${id}`, data);
  }

  static deleteCurrentMemberEmployer(id) {
    if (config.ENV.MOCK === true) {
      return MemberServiceMock.deleteCurrentMemberEmployer();
    }

    return HTTP.delete(`/api/currentmember/employers/${id}`);
  }

  static addCurrentMemberEmployer(data) {
    if (config.ENV.MOCK === true) {
      return MemberServiceMock.addCurrentMemberEmployer();
    }

    return HTTP.post('/api/currentmember/employers', data);
  }

  static changeLanguage(lang) {
    if (config.ENV.MOCK === true) {
      return MemberServiceMock.changeLanguage();
    }

    return HTTP.post(
      '/api/currentmember/preferences/language',
      {},
      {
        params: {
          twoLetterISOLanguage: lang,
        },
      },
    );
  }

  static getCurrentMemberPlacements() {
    if (config.ENV.MOCK === true) {
      return MemberServiceMock.getCurrentMemberPlacements();
    }

    return HTTP.get('/api/currentmember/placements');
  }

  static updateCurrentMemberPlacement(placement) {
    if (config.ENV.MOCK === true) {
      return MemberServiceMock.updateCurrentMemberPlacement();
    }

    return HTTP.put('/api/currentmember/placements', placement);
  }

  static authenticationValidate(args) {
    if (config.ENV.MOCK === true) {
      return MemberServiceMock.authenticationValidate(args);
    }

    return HTTP.post('/api/memberauthentication/AuthenticationValidate', args);
  }

  static authenticationCreate(args) {
    if (config.ENV.MOCK === true) {
      return MemberServiceMock.authenticationCreate();
    }

    return HTTP.post('/api/memberauthentication/AuthenticationCreate', args);
  }
}
